import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';
import Toast from 'src/components/toast';
import { getRegionList } from 'src/api/region';
import Logger from 'src/utils/logger';

const logger = new Logger('ShipInfo');

interface Prop {
    config: any;
    commodity: any;
    shippingFee: number;
    totalPrice: number;
    selectedPackage: any;
    onShipInfoChange: (spuAttr: any) => void;
    onSubmitOrder: (shipInfo: any) => void;
}
interface State {
    selectedDistribution: any;
    realName: string;
    realName0: string;
    realName1: string;
    phone: string;
    email: string;
    shipZipCode: string;
    shipZipCode0: string;
    shipZipCode1: string;
    shipMethod: string;
    detailAddress: string;
    selectedRegion: any[];
    remark: string;
    region: any[];
}

@injectIntl()
export default class ShipInfo extends Base<Prop, State> {
    private triggeredAddToCart: boolean = false;
    private distributionModeStyle: any = {
        TWN_HEIMAO_XINZHU: 'akmall-payment-payOnDelivery',
        TWN_SEVEN_ELEVEN: 'akmall-payment-711',
        TWN_FAMIPORT: 'akmall-payment-quanjia',
    };
    private zipCodeRegExp: RegExp = /^\d+-?\d*$/;
    private mailRegExp: RegExp =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    constructor(props: any) {
        super(props);
        this.state = {
            selectedDistribution: {},
            realName: '',
            realName0: '',
            realName1: '',
            phone: '',
            email: '',
            shipZipCode: '',
            shipZipCode0: '',
            shipZipCode1: '',
            shipMethod: '',
            detailAddress: '',
            selectedRegion: [],
            remark: '',
            region: [],
        };
    }

    private getRegionList = async (distributionMode: any = {}, parentLevel: number = 0, parentId: string | null = null) => {
        const { config } = this.props;
        const { promoteId } = this.props.commodity;
        const regionParams = {
            parentId,
            promoteId: promoteId,
            parentLevel: parentLevel,
            regionCode: config?.regionCode,
            distributionMode: distributionMode.value,
        };
        this.setState({ selectedDistribution: distributionMode });
        let response = await getRegionList(regionParams);
        return response;
    };

    changeHandler = ({
        realName0,
        realName1,
        phone,
        email,
        shipZipCode0,
        shipZipCode1,
        shipMethod,
        detailAddress,
        remark,
    }: any) => {
        this.setState(
            {
                realName0: realName0 ?? this.state.realName0,
                realName1: realName1 ?? this.state.realName1,
                realName: (realName0 ?? this.state.realName0) + (realName1 ?? this.state.realName1),
                phone: phone ?? this.state.phone,
                shipZipCode0: shipZipCode0 ?? this.state.shipZipCode0,
                shipZipCode1: shipZipCode1 ?? this.state.shipZipCode1,
                shipZipCode: (shipZipCode0 ?? this.state.shipZipCode0) + '-' + (shipZipCode1 ?? this.state.shipZipCode1),
                email: email ?? this.state.email,
                shipMethod: shipMethod ?? this.state.shipMethod,
                detailAddress: detailAddress ?? this.state.detailAddress,
                remark: remark ?? this.state.remark,
            },
            () => {
                const shipInfo = JSON.parse(JSON.stringify(this.state));
                this.props.onShipInfoChange(shipInfo);
            },
        );
    };

    changeDistributionHandler = async (dis: any) => {
        this.setState({ region: [] });
        const { data } = await this.getRegionList(dis);
        this.setState({ region: data, selectedDistribution: dis, selectedRegion: [] }, () => {
            if (data?.[0]?.level >= 0) {
                this.regionChangeHandler(data?.[0]?.value, data?.[0]?.level);
            }
            // this.props?.onShipInfoChange(JSON.parse(JSON.stringify(this.state)));
            const shipInfo = JSON.parse(JSON.stringify(this.state));
            this.props.onShipInfoChange(shipInfo);
        });
    };

    regionChangeHandler = async (value: string, level: number = -1) => {
        if (level === 1) {
            let findNode = false;
            for (let i = 0, iLen = this.state.region.length; i < iLen; i++) {
                const region = this.state.region[i];
                if (region.value === value) {
                    const { data } = await this.getRegionList(this.state.selectedDistribution, region.level, region.id);
                    region.children = data;
                    this.setState({ selectedRegion: [region] }, () => {
                        const shipInfo = JSON.parse(JSON.stringify(this.state));
                        this.props.onShipInfoChange(shipInfo);
                    });
                    findNode = true;
                    if (data?.length > 0) {
                        this.regionChangeHandler(data[0].value, level + 1);
                    }
                    break;
                }
            }
            if (!findNode) {
                this.setState({ selectedRegion: [] }, () => {
                    const shipInfo = JSON.parse(JSON.stringify(this.state));
                    this.props.onShipInfoChange(shipInfo);
                });
            }
        }
        if (level >= 2) {
            const { selectedRegion } = this.state;
            let findNode = false;
            for (let i = 0, iLen = selectedRegion[level - 2].children?.length; i < iLen; i++) {
                const region = selectedRegion[level - 2].children[i];
                if (region.value === value) {
                    const { data } = await this.getRegionList(this.state.selectedDistribution, region.level, region.id);
                    region.children = data;
                    selectedRegion.length = level - 1;
                    selectedRegion.push(region);
                    this.setState({ selectedRegion }, () => {
                        const shipInfo = JSON.parse(JSON.stringify(this.state));
                        this.props.onShipInfoChange(shipInfo);
                    });
                    findNode = true;
                    if (data?.length > 0) {
                        this.regionChangeHandler(data[0].value, level + 1);
                    }
                    break;
                }
            }
            if (!findNode) {
                const newSelectedRegion = selectedRegion.slice(0, level);
                newSelectedRegion[level - 1].children = [];
                this.setState({ selectedRegion: newSelectedRegion }, () => {
                    const shipInfo = JSON.parse(JSON.stringify(this.state));
                    this.props.onShipInfoChange(shipInfo);
                });
            }
        }
    };

    submitValidate = () => {
        const { realName, phone, email, shipMethod, shipZipCode, detailAddress, selectedRegion, selectedDistribution } =
            this.state;
        const { intl, config } = this.props;

        if (!realName?.trim()) {
            Toast.error(intl!.formatMessage({ id: 'input.name' }));
            return false;
        }
        if (!phone?.trim()) {
            Toast.error(intl!.formatMessage({ id: 'input.phone' }));
            return false;
        }
        if (selectedRegion?.length > 0) {
            //下拉框有多个，并且最后一个下拉框没有选中
            if (selectedRegion[selectedRegion.length - 1]?.children?.length > 0) {
                Toast.error(intl!.formatMessage({ id: 'ship-info.select-region' }));
                return false;
            }
            let noSelected = false;
            for (let i = 0, iLen = selectedRegion?.length; i < iLen; i++) {
                const reg = selectedRegion[i];
                if (!reg.value?.trim()) {
                    noSelected = true;
                    break;
                }
            }
            if (noSelected) {
                Toast.error(intl!.formatMessage({ id: 'ship-info.select-region' }));
                return false;
            }
        }

        if (!selectedDistribution.hideAddressInput && !detailAddress?.trim()) {
            Toast.error(intl!.formatMessage({ id: 'input.detail-address' }));
            return false;
        }

        if (config?.requiredConfig?.shipEmail?.required && !email) {
            Toast.error(intl!.formatMessage({ id: 'input.email' }));
            return false;
        }

        //input-wrong-email
        if (config?.requiredConfig?.shipEmail?.required && email && !this.mailRegExp.test(email)) {
            Toast.error(intl!.formatMessage({ id: 'input-wrong-email' }));
            return false;
        }

        if (config?.requiredConfig?.shipZipCode?.required && !shipZipCode) {
            Toast.error(intl!.formatMessage({ id: 'input.zip-code' }));
            return false;
        }

        //input-wrong-zipcode
        if (config?.requiredConfig?.shipZipCode?.required && shipZipCode && !this.zipCodeRegExp.test(shipZipCode)) {
            Toast.error(intl!.formatMessage({ id: 'input-wrong-zipcode' }));
            return false;
        }
        return true;
    };

    submitOrderHandler = async () => {
        const result = this.submitValidate();
        if (result) {
            const shipInfo = JSON.parse(JSON.stringify(this.state));
            this.props.onSubmitOrder(shipInfo);
        }
    };

    private initRegionList = async (commodity: any) => {
        const { data } = await this.getRegionList(commodity?.distributionModeArr?.[0]);
        this.setState({ region: data }, () => {
            if (data?.[0]?.level >= 0) {
                this.regionChangeHandler(data?.[0]?.value, data?.[0]?.level);
            }
        });
    };

    triggerAddToCartFbq = () => {
        if (this.triggeredAddToCart) {
            return;
        }
        this.triggeredAddToCart = true;
        const { config, commodity } = this.props;
        const { selectedPackage } = this.props;
        //FB像素处理
        if (config.hasFbPixel) {
            if (window.fbq) {
                try {
                    window.fbq?.('track', 'AddToCart', { value: selectedPackage.price, currency: commodity.currencyCode });
                } catch (error) {}
            }
        }
        if (config.hasTiktokAds) {
            if (window.ttq) {
                try {
                    window.ttq.track('AddToCart');
                } catch (error) {}
            }
        }
        if (config.hasLineAds) {
            if (window._lt) {
                try {
                    if (config.adsConfig.line?.tagId) {
                        window._lt('send', 'cv', { type: 'AddToCart' }, [config.adsConfig.line?.tagId]);
                    }
                } catch (error) {}
            }
        }
        if (config.hasGoogleAds) {
            if (window.gtag) {
                try {
                    if (config.adsConfig.google.conversionLabelAddToCart) {
                        window.gtag('event', 'conversion', {
                            send_to:
                                'AW-' +
                                config.adsConfig.google.conversionId +
                                '/' +
                                config.adsConfig.google.conversionLabelAddToCart,
                            value: selectedPackage.price,
                            currency: commodity.currencyCode,
                        });
                    }
                } catch (error) {}
            }
        }
    };

    componentDidMount() {
        const { commodity } = this.props;
        if (!commodity.id) {
            return;
        }
        this.initRegionList(commodity);
    }

    componentDidUpdate(preProps: Prop, preState: State) {
        const { commodity: oldCommodity } = preProps;
        const { commodity: newCommodity } = this.props;

        if (oldCommodity?.id !== newCommodity?.id && newCommodity?.id) {
            this.initRegionList(newCommodity);
        }
    }

    render() {
        const { commodity, shippingFee, totalPrice, intl, config } = this.props;
        const { selectedDistribution, selectedRegion } = this.state;
        return (
            <>
                <div className="boxs white_bg">
                    {/* <!--收貨信息-->  */}
                    <table cellPadding={0} cellSpacing={0} className="addbox">
                        <tbody>
                            <tr>
                                <td className="abtitle">
                                    <FormattedMessage id="payment" />
                                </td>
                                <td className="abinput payme">
                                    {commodity?.distributionModeArr?.map((dis: any) => {
                                        return (
                                            <label onClick={this.changeDistributionHandler.bind(this, dis)} key={dis.value}>
                                                <input
                                                    name="payment_type"
                                                    type="radio"
                                                    key={dis.label}
                                                    defaultValue={dis.value}
                                                    checked={selectedDistribution.value === dis.value}
                                                    onChange={() => {}}
                                                />
                                                {dis.label}
                                            </label>
                                        );
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle" width="80">
                                    <span style={{ color: 'red' }}>*</span>
                                    <FormattedMessage id="ship-info.name" />
                                </td>
                                <td className="abinput">
                                    <input
                                        type="text"
                                        name="name0"
                                        maxLength={100}
                                        className="writebtn"
                                        placeholder={intl?.formatMessage({
                                            id: 'input.name',
                                        })}
                                        style={{ width: '90%' }}
                                        onBlur={event => {
                                            this.changeHandler({ realName0: event.target.value });
                                            this.triggerAddToCartFbq();
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    <span style={{ color: 'red' }}>*</span>
                                    <FormattedMessage id="ship-info.phone" />
                                </td>
                                <td className="abinput">
                                    <span>+48</span>
                                    <input
                                        type="tel"
                                        name="mob"
                                        maxLength={9}
                                        className="writebtn"
                                        placeholder={intl?.formatMessage({ id: 'input.phone' })}
                                        style={{ marginLeft: '5px', width: '83%' }}
                                        defaultValue=""
                                        onBlur={event => {
                                            this.changeHandler({ phone: '+48' + event.target.value });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    <span style={{ color: 'red' }}>*</span>
                                    <FormattedMessage id="ship-info.region" />
                                </td>
                                <td className="abinput">
                                    <select
                                        name="region[province]"
                                        id="province"
                                        onChange={e => {
                                            this.regionChangeHandler(e.target.value, 1);
                                        }}
                                    >
                                        {this.state.region.map(reg => {
                                            return (
                                                <option key={reg.value} value={reg.value}>
                                                    {reg.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    {this.state?.selectedRegion?.map((reg: any, index: number) => {
                                        if (!reg?.children?.length) {
                                            return null;
                                        }
                                        return (
                                            <select
                                                key={reg.value + index}
                                                style={{ maxWidth: '49%' }}
                                                name="region[city]"
                                                className="akmall-region akmall-region-city"
                                                onChange={e => {
                                                    this.regionChangeHandler(e.target.value, index + 2);
                                                }}
                                            >
                                                {reg?.children.map((childReg: any) => {
                                                    return (
                                                        <option key={childReg.value} value={childReg.value}>
                                                            {childReg.label}
                                                        </option>
                                                    );
                                                })}
                                            </select>
                                        );
                                    })}
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    <span style={{ color: 'red' }}>*</span>
                                    <FormattedMessage id="ship-info.detail-address" />
                                </td>
                                <td className="abinput">
                                    {!selectedDistribution.hideAddressInput && (
                                        <div className="region-select region-payOnDelivery">
                                            <textarea
                                                id="address"
                                                name="address"
                                                maxLength={300}
                                                placeholder={intl?.formatMessage({
                                                    id: 'input.detail-address',
                                                })}
                                                onBlur={event => {
                                                    this.changeHandler({ detailAddress: event.target.value });
                                                }}
                                            ></textarea>
                                        </div>
                                    )}
                                    {selectedDistribution.hideAddressInput && (
                                        <label>{selectedRegion.map(reg => (reg.value ? reg.label : '')).join(' ')}</label>
                                    )}
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    {config?.requiredConfig?.shipZipCode?.required && <span style={{ color: 'red' }}>*</span>}
                                    <FormattedMessage id="zip-code" />
                                </td>
                                <td className="abinput">
                                    <input
                                        type="text"
                                        name="postal0"
                                        maxLength={2}
                                        placeholder="xx"
                                        style={{
                                            width: '16%',
                                        }}
                                        onBlur={event => {
                                            this.changeHandler({ shipZipCode0: event.target.value });
                                        }}
                                    />

                                    <span>
                                        <span>-</span>
                                        <input
                                            type="text"
                                            name="postal1"
                                            maxLength={3}
                                            placeholder="xxx"
                                            style={{ width: '20%' }}
                                            onBlur={event => {
                                                this.changeHandler({ shipZipCode1: event.target.value });
                                            }}
                                        />
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    {config?.requiredConfig?.shipEmail?.required && <span style={{ color: 'red' }}>*</span>}
                                    <FormattedMessage id="email" />
                                </td>
                                <td className="abinput">
                                    <input
                                        type="text"
                                        name="email"
                                        maxLength={100}
                                        placeholder={intl?.formatMessage({ id: 'input.email' })}
                                        defaultValue=""
                                        onBlur={event => {
                                            this.changeHandler({ email: event.target.value });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td className="abtitle">
                                    <FormattedMessage id="ship-info.message" />
                                </td>
                                <td className="abinput">
                                    <textarea
                                        name="guest"
                                        maxLength={300}
                                        placeholder={intl?.formatMessage({ id: 'input.message' })}
                                        onBlur={event => {
                                            this.changeHandler({ remark: event.target.value });
                                        }}
                                    ></textarea>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="order_check">
                        <p className="combo_freight" style={{ fontSize: '14px', margin: '0px', color: 'red' }}>
                            <FormattedMessage id="freight-charge" />：
                            {commodity.currencyDisplayPosition === 'BEFORE_AMOUNT' && commodity.currencyDisplay}
                            <em>{shippingFee}</em>
                            {commodity.currencyDisplayPosition === 'AFTER_AMOUNT' && commodity.currencyDisplay}
                        </p>
                        <span className="totlebox">
                            <FormattedMessage id="ship-info.total" />
                            :&nbsp; {commodity.currencyDisplayPosition === 'BEFORE_AMOUNT' && commodity.currencyDisplay}
                            &nbsp;<span className="totle show_price">{totalPrice}</span>&nbsp;
                            {commodity.currencyDisplayPosition === 'AFTER_AMOUNT' && commodity.currencyDisplay}
                        </span>
                    </div>
                    <div className="submit s_btn_submitorder" onClick={this.submitOrderHandler}>
                        <button type="submit">
                            <FormattedMessage id="ship-info.submit-order" />
                        </button>
                    </div>
                </div>
            </>
        );
    }
}
